import React, { FunctionComponent } from 'react';
import { PersonShowMainItem } from '../../molecules/personShowMainItem';
import { ResumeStates, JobResumeStates } from '../../../types/personShow';

type Props = {
  mainTitle: string;
  penIconImg: string;
  resume: "" | File | { name: { url: string; } };
  job_resume: "" | File | { name: { url: string; } };
  resumeUpdatedAt?: string;
  jobResumeUpdatedAt?: string;
  isShow: boolean;
  isStudent: boolean;
  personId: number;
  isNotRequestedResume: boolean;
  isNotRequestedJobResume: boolean;
  shouldDisplaySection: boolean;
  shouldDisplay: (value: any) => boolean;
  handleClick: (target: string, title: string) => void;
  handleRequestResumeClick: (type: string) => void;
  isOneYearPassed: boolean;
};

export const Presentation: FunctionComponent<Props> = ({
  mainTitle,
  penIconImg,
  resume,
  job_resume,
  resumeUpdatedAt,
  jobResumeUpdatedAt,
  isShow,
  isStudent,
  personId,
  isNotRequestedResume,
  isNotRequestedJobResume,
  shouldDisplaySection,
  shouldDisplay,
  handleClick,
  handleRequestResumeClick,
  isOneYearPassed,
}) => {
  if (isOneYearPassed) return null;
  if (!shouldDisplaySection) return null;

  return (
    <>
      <hr className="person__show__main--devide" />
      <h2 className="mainTitle">{mainTitle}</h2>
      {shouldDisplay(resume) && (
        <PersonShowMainItem
          penIconImg={penIconImg}
          title="履歴書"
          value={resume instanceof File ? resume.name : resume}
          updatedAt={resumeUpdatedAt}
          type="resume"
          id="resume"
          handleClick={handleClick}
          isShow={isShow}
          personId={personId}
          word="追加する"
          isNotRequested={isNotRequestedResume}
          handleRequestResume={handleRequestResumeClick}
        />
      )}
      {shouldDisplay(job_resume) && !isStudent && (
        <PersonShowMainItem
          penIconImg={penIconImg}
          title="職務経歴書"
          value={job_resume instanceof File ? job_resume.name : job_resume}
          updatedAt={jobResumeUpdatedAt}
          type="resume"
          id="job_resume"
          handleClick={handleClick}
          isShow={isShow}
          personId={personId}
          word="追加する"
          isNotRequested={isNotRequestedJobResume}
          handleRequestResume={handleRequestResumeClick}
        />
      )}
    </>
  );
};
